import React, { useState } from 'react';
import { Wand2, Captions, Scissors, Mic2, Sparkles, Music, ArrowUpRight } from 'lucide-react';
import { useLang } from '../context/LangContext';
import { featureImages } from '../mock/data';

const icons = [Wand2, Captions, Scissors, Mic2, Sparkles, Music];
const tints = [
  'from-cyan-400 to-blue-500',
  'from-fuchsia-400 to-pink-500',
  'from-amber-400 to-orange-500',
  'from-emerald-400 to-teal-500',
  'from-violet-400 to-indigo-500',
  'from-rose-400 to-red-500'
];

const Features = () => {
  const { t } = useLang();
  const [hover, setHover] = useState(null);

  return (
    <section id="features" className="py-24 md:py-32 bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-16">
          <span className="inline-block text-[13px] font-bold tracking-widest uppercase text-cyan-600 mb-4">{t.features.sectionLabel}</span>
          <h2 className="text-[40px] md:text-[56px] font-black tracking-[-0.02em] leading-[1.05] text-neutral-900">
            {t.features.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.features.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                onMouseEnter={() => setHover(i)}
                onMouseLeave={() => setHover(null)}
                className="group relative bg-white rounded-3xl p-7 border border-neutral-200/70 hover:border-neutral-900 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer overflow-hidden"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${tints[i]} flex items-center justify-center shadow-md`}>
                    <Icon className="w-6 h-6 text-white" strokeWidth={2.2} />
                  </div>
                  <span className="text-[11px] font-bold uppercase tracking-wider bg-neutral-100 text-neutral-700 rounded-full px-2.5 py-1">{item.tag}</span>
                </div>
                <h3 className="text-[20px] font-bold text-neutral-900 mb-2 tracking-tight">{item.title}</h3>
                <p className="text-[14.5px] text-neutral-600 leading-relaxed">{item.desc}</p>
                <div className="mt-6 flex items-center gap-1.5 text-[13px] font-semibold text-neutral-900 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>Utforska</span>
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
                <div className="absolute -bottom-16 -right-16 w-40 h-40 rounded-full bg-gradient-to-br opacity-0 group-hover:opacity-10 blur-2xl transition-opacity duration-500" style={{background: `linear-gradient(135deg, var(--tw-gradient-stops))`}} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
